import { Component, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { PlanAniosService } from '../modulos/catalogos-admin/services/plan-anios.service';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { UsuarioRedux } from '../models/usuario.model';
import * as globalAccions from './../redux/global/global.actions'
import { DatePipe } from '@angular/common';
import { forkJoin, map } from 'rxjs';
import { PlanInstitucionalService } from '../modulos/catalogos-admin/services/plan-institucional.service';
import { AniosObjetivosService } from '../modulos/catalogos-admin/services/anios-objetivos.service';
import { AniosService } from '../modulos/catalogos-admin/services/anios.service';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit {

  public formSelectAnioLayout!: UntypedFormGroup;
  public submitted = false;
  public idSprSelectAnio: number = 0;
  public idSprTargetAnio: number = 0;
  public dataAnios: any = [];
  dataAniosPlanInst:any [];
  public dataPlanAnios: any = [];
  public dataPlanesInst: any = [];
  public idSprAmbiente!: number;
  public anioSelec: any = new Date().getFullYear() ; // validacion para inico de cada plan año
  public planAniosSelect: any = null ; // validador de fechas del plan redux
  public ambienteSelected: any = null ; // validador de fechas del plan redux
  currentUserRedux: UsuarioRedux=null;
  anioActual: string = '';
  pipe = new DatePipe('en-US');
  hoy = new Date();
  public idSprAnio: number = 0;
  public nombreUnidad: string = "N/A";
  public nivelActual: string = "N/A";



  constructor(
    private fb: FormBuilder,
    private aniosService: AniosService,
    private planInstitucionalAnios:PlanInstitucionalService,
    private planesAniosService:PlanAniosService,
    private store: Store<AppState>,
  ) {
    this.anioActual = this.pipe.transform(this.hoy, 'YYYY');
  }

  ngOnInit(): void {
    this.store.select("globalApp").subscribe((response)=>{// redux
      this.planAniosSelect = response.planAniosSeleccionado;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente
      this.nombreUnidad = response.ambienteSeleccionado.nombreUnidad
      this.nivelActual = response.ambienteSeleccionado.nivel.nombre
    
      //if(!response.planAniosSeleccionado == null){
        this.idSprSelectAnio = (response.planAniosSeleccionado.idSprPlanAnio) ? response.planAniosSeleccionado.idSprPlanAnio : 0;
        
      //}
    });

    this.store.select("usuarioApp").subscribe((response)=>{
      this.currentUserRedux = response.currentUser;
    });
    this.initApp()
  }

  initApp() {
    this.setSelectAnioForm();
    this.getDataAnios()
  }

  setSelectAnioForm() {
    
    this.formSelectAnioLayout = this.fb.group({
      idSprAnioSelectedLayout: [this.idSprSelectAnio],
    });

  }

  changeAnioSelectedLayout(e: any) {
   
    this.idSprTargetAnio = e.target.value;
    this.idSprAnio = e.target.value;
    for (let i = 0; i < this.dataAnios.length; i++) {
      if (this.dataAnios[i].idSprAnio == this.idSprTargetAnio) {
        this.anioSelec = this.dataAnios[i].anio;
      }
    }
    if(this.currentUserRedux){

   
      this.store.dispatch(globalAccions.planAniosSeleccionado({idPlan: this.idSprTargetAnio}))
    }
  }

  getDataAnios() {
      forkJoin([
    
        this.aniosService.list(),
        this.planInstitucionalAnios.list(),
        this.planesAniosService.list(`?estado=${1}`)
       
      ]).pipe(map(
        ([anios,planInstitucional,planAnios,]) => {
          this.dataAnios=anios;
          this.dataPlanesInst=planInstitucional;
          this.dataPlanAnios=planAnios;
          this.mapearDataAniosPlanes();
        })).subscribe();
    


  }

  mapearDataAniosPlanes(){
let dataDrive = [];
    for(let i = 0; i < this.dataPlanesInst.length; i++){
      for(let j = 0; j < this.dataPlanAnios.length; j++){
        if((this.dataPlanesInst[i].idSprPlanInstitucional == this.dataPlanAnios[j].idSprPlanInstitucional) ) {
          for(let k = 0; k < this.dataAnios.length; k++){
            if(this.dataAnios[k].idSprAnio == this.dataPlanAnios[j].idSprAnio) {             
                dataDrive.push({
                  idSprPlanAnio:this.dataPlanAnios[j].idSprPlanAnio,
                  idSprAnio:this.dataPlanAnios[j].idSprAnio,
                  idSprPlanInstitucional:this.dataPlanAnios[j].idSprPlanInstitucional,
                  anio:this.dataAnios[k].anio,
                  nombrePlan:this.dataPlanesInst[i].nombre,
                  fechaInicio:this.dataPlanAnios[j].fechaInicio,
                  fechaFin:this.dataPlanAnios[j].fechaFin,
                  vigencia:this.dataPlanAnios[j].vigencia,
                })
              }
            }
          }
        }
      }
      this.dataAniosPlanInst = dataDrive;
      //dataDrive=[];

}

  setAnioSelect() {
    let anioSeleccionar = 0;
    for (let i = 0; i < this.dataAnios.length; i++) {
      if (this.dataAnios[i].anio == this.anioActual) {
        this.idSprSelectAnio = this.dataAnios[i].idSprAnio;
        anioSeleccionar = this.dataAnios[i].anio;

      }
    }
    this.setSelectAnioForm();
    this.idSprTargetAnio = this.idSprSelectAnio
  }

}

